var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authors"},_vm._l((_vm.authorsData),function(author){return _c('router-link',{key:author.id,staticClass:"author",attrs:{"to":'/author/' + author.id}},[_vm._v("\n    "+_vm._s(author.name)+"\n  ")])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b0aa632","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LibraryAuthors.vue
// module id = 1534
// module chunks = 0